<p class="breadcrumb">
  <span>{{ texts.label }}</span>
  <span class="breadcrumb__current">{{ texts.current }}</span>
</p>
